// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"189":"9555b7ad","360":"4cbfb1dc","537":"68c3c51a","560":"8a356d62","575":"7169ec5e","823":"ce1156d2","848":"02302231"}[chunkId] + ".chunk.js";
};